import { DefaultValue, selector, selectorFamily } from 'recoil'
import { currentAlertState } from './atom'
import { AlertData } from './types'

export const removeAlertQuery = selectorFamily<AlertData, AlertData>({
  key: 'RemoveAlertQuery',
  get:
    (value) =>
    ({ get }) =>
      get(currentAlertState).find((a) => a.message === value.message),
  set:
    (value) =>
    ({ set, get }) => {
      const current = get(currentAlertState)
      const newData: AlertData[] = [...current.filter((a) => a.message !== value.message)]
      set(currentAlertState, newData)
    },
})

export const addAlertQuery = selector<AlertData[]>({
  key: 'AddAlertQuery',
  get: ({ get }) => get(currentAlertState),
  set: ({ set, get }, value) => {
    const current = get(currentAlertState)
    const newData: AlertData[] = [...current]
    if (!(value instanceof DefaultValue)) {
      newData.push(...value)
    }
    set(currentAlertState, newData)
  },
})
